/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { get, isEmpty } from "lodash"

function SEO({
  description,
  lang,
  meta,
  image,
  title,
  pathname,
  author,
  datePublished = false,
  dateModified = false,
  currentCatag,
  template,
  seoType,
  catagory,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description

  const extraMeta = []

  if (seoType === "template") {
    extraMeta.push(
      {
        name: `title`,
        content: `${template.data.Title} | ${template.data.Catagory[0]} Template for Gutenberg`,
      },
      {
        name: `og:title`,
        content: `${template.data.Title} | ${template.data.Catagory[0]} Template for Gutenberg`,
      },
      {
        name: `twitter:title`,
        content: `${template.data.Title} | ${template.data.Catagory[0]} Template for Gutenberg`,
      }
    )
    extraMeta.push(
      {
        name: "image",
        content: get(template.data, "Screenshot[0].url"),
      },
      {
        name: `twitter:image`,
        content: get(template.data, "Screenshot[0].url"),
      },
      {
        name: `og:image`,
        content: get(template.data, "Screenshot[0].url"),
      },
      {
        property: "og:image:alt",
        content: template.data.Title,
      },
      {
        property: "twitter:image:alt",
        content: template.data.Title,
      }
    )
  }

  if (seoType === "home") {
    extraMeta.push(
      {
        name: `title`,
        content: site.siteMetadata.title,
      },
      {
        name: `og:title`,
        content: site.siteMetadata.title,
      },
      {
        name: `twitter:title`,
        content: site.siteMetadata.title,
      }
    )

    extraMeta.push(
      {
        name: `description`,
        content: site.siteMetadata.description,
      },
      {
        property: `og:description`,
        content: site.siteMetadata.description,
      },
      {
        name: `twitter:description`,
        content: site.siteMetadata.description,
      }
    )

    extraMeta.push(
      {
        name: "image",
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        name: `twitter:image`,
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        name: `og:image`,
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        property: "og:image:alt",
        content: "Gutenberg Templates",
      },
      {
        property: "twitter:image:alt",
        content: "Gutenberg Templates",
      }
    )
  }

  if (seoType === "catagory") {
    extraMeta.push(
      {
        name: `title`,
        content: `${catagory} Section Templates for Gutenberg`,
      },
      {
        name: `og:title`,
        content: `${catagory} Section Templates for Gutenberg`,
      },
      {
        name: `twitter:title`,
        content: `${catagory} Section Templates for Gutenberg`,
      }
    )

    extraMeta.push(
      {
        name: `description`,
        content: `Collection of FREE ${catagory} Section Templates for Gutenberg. Browse, Copy and Paste any template you like. No Plugin Required.`,
      },
      {
        property: `og:description`,
        content: `Collection of FREE ${catagory} Section Templates for Gutenberg. Browse, Copy and Paste any template you like. No Plugin Required.`,
      },
      {
        name: `twitter:description`,
        content: `Collection of FREE ${catagory} Section Templates for Gutenberg. Browse, Copy and Paste any template you like. No Plugin Required.`,
      }
    )
    extraMeta.push(
      {
        name: "image",
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        name: `twitter:image`,
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        name: `og:image`,
        content:
          "http://gutenberghub.com/wp-content/uploads/2020/03/Gutenberg-Hub-cover.png",
      },
      {
        property: "og:image:alt",
        content: "Gutenberg Templates",
      },
      {
        property: "twitter:image:alt",
        content: "Gutenberg Templates",
      }
    )
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={extraMeta.concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
